import * as React from 'react';
import { useState } from 'react';
import { styled } from '@mui/material/styles';
import MuiDrawer from '@mui/material/Drawer';
import Divider from '@mui/material/Divider';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import InboxIcon from '@mui/icons-material/MoveToInbox';
import MailIcon from '@mui/icons-material/Mail';
import logo from '../../../assets/images/ebasket-logo_1720446251933.png';
import logoClosed from '../../../assets/images/logo-light-icon.png';
import { Link } from 'react-router-dom';
import { Box } from '@mui/material';
// Importing icons
import HomeIcon from '@mui/icons-material/Home';
import MyLocationIcon from '@mui/icons-material/MyLocation';
import PeopleIcon from '@mui/icons-material/People';
import DriveEtaIcon from '@mui/icons-material/DriveEta';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import AssignmentIcon from '@mui/icons-material/Assignment';
import SalesReportIcon from '@mui/icons-material/Assessment';
import CategoryIcon from '@mui/icons-material/Category';
import BrandIcon from '@mui/icons-material/BrandingWatermark';
import ItemIcon from '@mui/icons-material/Storefront';
import OrderIcon from '@mui/icons-material/ShoppingCart';
import CouponIcon from '@mui/icons-material/LocalOffer';
import NotificationIcon from '@mui/icons-material/Notifications';
import PaymentIcon from '@mui/icons-material/Payment';
import BannerIcon from '@mui/icons-material/Adb';
import EmailIcon from '@mui/icons-material/Email';
import CmsIcon from '@mui/icons-material/Pages';
import SettingsIcon from '@mui/icons-material/Settings';
import Collapse from '@mui/material/Collapse';
import Typography from '@mui/material/Typography';
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

const drawerWidth = 240;
// const closeWidth = 80;

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: 'hidden',
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: 'hidden',
  width: `calc(${theme.spacing(26)} + 1px) !important`,
  [theme.breakpoints.up('sm')]: {
    width: `calc(${theme.spacing(26)} + 1px)`,
  },
});

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
}));

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme }) => ({
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap',
    boxSizing: 'border-box',
    variants: [
      {
        props: ({ open }) => open,
        style: {
          ...openedMixin(theme),
          '& .MuiDrawer-paper': openedMixin(theme),
        },
      },
      {
        props: ({ open }) => !open,
        style: {
          ...closedMixin(theme),
          '& .MuiDrawer-paper': closedMixin(theme),
        },
      },
    ],
  }),
);
const iconsMap = {
  'Dashboard': <HomeIcon />,
  'Live Tracking': <DriveEtaIcon />,
  'Access control': <PeopleIcon />,
  'Users / Customer': <PeopleIcon />,
  'Drivers': <DriveEtaIcon />,
  'Sales Report': <SalesReportIcon />,
  'Categories': <CategoryIcon />,
  'Brands': <BrandIcon />,
  'Items': <ItemIcon />,
  'Item Attribute': <AssignmentIcon />,
  'Orders': <OrderIcon />,
  'Coupons': <CouponIcon />,
  'Notifications': <NotificationIcon />,
  'Payments': <PaymentIcon />,
  'Banner Items': <BannerIcon />,
  'Email Templates': <EmailIcon />,
  'CMS Pages': <CmsIcon />,
  'Settings': <SettingsIcon />,
};
const routeMap = {
  'Dashboard': '/dashboard',
  'Live Tracking': '/live-tracking',
  'Access control': '/access-control',
  'Users / Customer': '/users-customer',
  'Sales Report': '/sales-report',
  'Categories': '/categories',
  'Brands': '/brands',
  'Items': '/items',
  'Orders': '/orders',
  'Coupons': '/coupons',
  'Notifications': '/notifications',
  'Payments': '/payments',
  'Banner Items': '/banner-items',
  'Email Templates': '/email-templates',
  'CMS Pages': '/cms-pages',
  'Settings': '/settings',
};

export default function MobileSidebar({ open, sideBarMenu,handleClose}) {
  const [ordersOpen, setOrdersOpen] = React.useState(false);
  
    const toggleOrdersMenu = () => {
      setOrdersOpen((prev) => !prev);
    };

  return (
    <Drawer className='mobileSidebar-cls' sx={{ display: { xs: "block", md: "none" } }} variant="permanent" open={open} >
      <Divider />
      <List className='sidebar-menu-cls' sx={{ bgcolor: '#3C7F10', color: '#fff' }}>
          {sideBarMenu.map((text, index) => (
            <React.Fragment key={text}>
              {text === 'Orders' ? (
                <>
                  <ListItemButton
                    onClick={toggleOrdersMenu}
                    sx={[
                      { minHeight: 48, px: 2.5 },
                      open ? { justifyContent: 'initial' } : { justifyContent: 'center' },
                    ]}
                  >
                    <ListItemIcon
                      sx={[
                        { minWidth: 0, justifyContent: 'center',mr: 1 }
                      ]}
                    >
                      {iconsMap[text]}
                    </ListItemIcon>
                    <ListItemText
                      primary={text}
                    />
                    {/* Rotating Arrow */}
                    <ArrowForwardIosIcon
                      sx={{
                        width: '15px',
                        height: '15px',
                        transform: ordersOpen ? 'rotate(90deg)' : 'rotate(0)',
                        transition: 'transform 0.3s ease',
                      }}
                    />
                  </ListItemButton>
  
                  {/* Slide-down Submenu */}
                  <Collapse in={ordersOpen}>
                    <List component="div" disablePadding>
                      <ListItemButton sx={{ pl: 2.5 }} component={Link} to="/orders">
                        <RadioButtonCheckedIcon sx={{ width: '15px', height: '15px' }} />
                        <ListItemText sx={{ paddingLeft: 3 }}
                          primary={
                            <Typography variant="body2">
                              Orders
                            </Typography>
                          }
                        />
                      </ListItemButton>
                      <ListItemButton sx={{ pl: 2.5 }} component={Link} to="/pending-driver-allocation">
                        <RadioButtonCheckedIcon sx={{ width: '15px', height: '15px' }} />
                        <ListItemText sx={{ paddingLeft: 3}}
                          primary={
                            <Typography variant="body2">
                              Pending Driver <br/> Allocation
                            </Typography>
                          }
                        />
                      </ListItemButton>
                    </List>
                  </Collapse>
                </>
              ) : (
                <ListItem disablePadding sx={{ display: 'block' }}>
                  <ListItemButton
                    component={Link}
                    to={routeMap[text] || `/${text.replace(/\s+/g, '-').toLowerCase()}`}
                    sx={[
                      { minHeight: 48, px: 2.5 },
                      open ? { justifyContent: 'initial' } : { justifyContent: 'center' },
                    ]}
                  >
                    <ListItemIcon
                      sx={[
                        { minWidth: 0, justifyContent: 'center', mr: 1 },
                      ]}
                    >
                      {iconsMap[text] || <InboxIcon />}
                    </ListItemIcon>
                    <ListItemText
                      primary={text}
                    />
                  </ListItemButton>
                </ListItem>
              )}
            </React.Fragment>
          ))}
      </List>
      <Divider />
    </Drawer>
  );
}
